import { useCallback, useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Services from "../components/Services";
import Calculator from "../components/Calculator";
import Portfolio from "../components/Portfolio";
import Qualifications from "../components/Qualifications";
import WhyChoose from "../components/WhyChoose";
import Areas from "../components/Areas";
import EnquiryForm from "../components/EnquiryForm";
import Footer from "../components/Footer";
import { initSmoothScroll, scrollToId } from "../lib/scroll";

export default function LandingPage() {
  const [prefillService, setPrefillService] = useState("");
  const [estimateMsg, setEstimateMsg] = useState("");

  useEffect(() => initSmoothScroll(), []);

  const handleEnquire = useCallback((service) => {
    setPrefillService(service);
    scrollToId("enquiry");
  }, []);

  const handleEstimate = useCallback((summary) => {
    setEstimateMsg(summary);
    scrollToId("enquiry");
  }, []);

  return (
    <div className="relative overflow-x-clip" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services onEnquire={handleEnquire} />
        <Calculator onGetQuote={handleEstimate} />
        <Portfolio />
        <Qualifications />
        <WhyChoose />
        <Areas />
        <EnquiryForm prefillService={prefillService} estimateMsg={estimateMsg} />
      </main>
      <Footer />
    </div>
  );
}
